// Words starting with an aspirated h: no elision ("du Hall", not "de l'Hall")
// Same rule and list in company, app, app.admin and app-mobile-interim.
const ASPIRATED_H = ["hach", "haie", "hall", "hand", "hang", "hard", "harn", "hau", "hock", "homard", "hors", "hou", "hub", "huit", "hurl"];

const startsWithVowelSound = (title) => {
  const normalized = title.trim().toLowerCase();
  if (!normalized) return false;
  if (normalized.startsWith("h")) {
    return !ASPIRATED_H.some((word) => normalized.startsWith(word));
  }
  return /^[aeiouàâäéèêëîïôöùûüœæ]/.test(normalized);
};

// "Tâches du Cariste H/F", "Tâches de l'Agent de quai H/F"
export const getMissionTasksTitle = (language, missionTitle) => {
  const title = (missionTitle ?? "").trim();
  const prefix = startsWithVowelSound(title)
    ? language.getValue("mission.tasks_title_elided", "Tâches de l'")
    : language.getValue("mission.tasks_title", "Tâches du ");
  return `${prefix}${title}`;
};
